import {
  getCubeLinesIdsByProjectIdApi,
  getCubeLineValueForTabApi,
  updateCubeLineValueForTabApi,
} from '@core/core/api'
import type { CubeLinesForTabs } from '@core/core/types'
import type { CubeId, CubeLineId, CubeLinesType, ProjectId, TabId } from 'common/types'

import type { AppThunk } from '../store'
import {
  selectCubeLineForTabById,
  selectCubeLineIdByType,
  selectCubeLinesForTab,
} from './cubeLineForTabSelectors'
import { cubeLineForTabSlice } from './cubeLineForTabSlice'

const { addCubeLineForTab, createCubeLinesForTab, updateLineValueForTab } =
  cubeLineForTabSlice.actions

const updateCubeLineValue =
  (cubeLineId: CubeLineId, projectId: ProjectId, tabId: TabId, lineValue: number): AppThunk =>
  dispatch => {
    dispatch(updateLineValueForTab({ tabId, cubeLineId, lineValue }))
    updateCubeLineValueForTabApi({ lineId: cubeLineId, lineValue, projectId, tabId })
  }

export const getCubeLineForTab =
  (cubeIds: CubeId[], projectId: ProjectId, tabId: TabId): AppThunk =>
  async (dispatch, getState) => {
    const state = getState()
    const cubeLines = selectCubeLinesForTab(state, tabId)
    const cubeLineForTab = selectCubeLineForTabById(state, tabId)

    const newCubesIds = cubeIds.filter(cubeId => !cubeLines?.some(cl => cl.cubeId === cubeId))
    const newCubeLineForTab: CubeLinesForTabs = { tabId, cubeLines: [] }

    for (const id of newCubesIds) {
      if (!id) {
        continue
      }

      const cubeLines = await getCubeLines(id, projectId, tabId)
      newCubeLineForTab.cubeLines.push(cubeLines)
    }

    if (!cubeLineForTab) {
      dispatch(createCubeLinesForTab(newCubeLineForTab))
    } else {
      dispatch(addCubeLineForTab(newCubeLineForTab))
    }
  }

const getCubeLines = async (cubeId: CubeId, projectId: ProjectId, tabId: TabId) => {
  const { Hline, iLine, xLine } = await getCubeLinesIdsByProjectIdApi(cubeId, projectId)
  const [iLineValue, xLineValue, hLineValue] = await Promise.all([
    getCubeLineValueForTabApi({ lineId: iLine, projectId, tabId }),
    getCubeLineValueForTabApi({ lineId: xLine, projectId, tabId }),
    getCubeLineValueForTabApi({ lineId: Hline, projectId, tabId }),
  ])
  return {
    cubeId,
    isActive: true,
    Hline: {
      cubeLineId: Hline,
      value: hLineValue,
    },
    iLine: {
      cubeLineId: iLine,
      value: iLineValue,
    },
    xLine: {
      cubeLineId: xLine,
      value: xLineValue,
    },
  }
}

export const updateCubeLineValueByLineType =
  (
    lineType: CubeLinesType,
    projectId: ProjectId,
    tabId: TabId,
    cubeId: CubeId,
    lineValue: number,
  ): AppThunk =>
  (dispatch, getState) => {
    const state = getState()
    const cubeLineId = selectCubeLineIdByType(state, tabId, cubeId, lineType)
    if (cubeLineId) {
      dispatch(updateCubeLineValue(cubeLineId, projectId, tabId, lineValue))
    }
  }
